import React, { useState, useEffect } from "react";
import "./ApprovalModal.css";

const ApprovalModal = ({
  open,
  onClose,
  onSubmit,
  projectData,
  isSubmitting = false,
}) => {
  const [checked, setChecked] = useState([]);
  const [approvers, setApprovers] = useState([]);

  // Инициализация списка согласующих на основе данных проекта
  useEffect(() => {
    if (projectData) {
      const approversList = [];

      // Директор компании (обязательный) - ID 41
      approversList.push({
        id: 41,
        title: "Директор компании",
        name: "Бекбауов Серикпай",
        isRequired: true,
      });

      // Финансовый руководитель (обязательный) - ID 62
      approversList.push({
        id: 62,
        title: "Финансовый руководитель",
        name: "Тлеубаева Бакыт",
        isRequired: true,
      });

      // ГИП проекта (обязательный) - если есть данные о ГИП
      if (projectData.chief) {
        const chiefName = `${projectData.chief.name || ""} ${
          projectData.chief.surname || ""
        }`.trim();
        approversList.push({
          id: projectData.chief.id || "chief",
          title: "ГИП проекта",
          name: chiefName || "Не назначен",
          isRequired: true,
        });
      }

      setApprovers(approversList);

      // По умолчанию выбираем всех обязательных согласующих
      const requiredIds = approversList
        .filter((approver) => approver.isRequired)
        .map((approver) => approver.id);
      setChecked(requiredIds);
    }
  }, [projectData]);

  if (!open) return null;

  const handleToggle = (id) => {
    // Проверяем, является ли согласующий обязательным
    const approver = approvers.find((a) => a.id === id);
    if (approver && approver.isRequired) {
      // Обязательных согласующих нельзя снять
      return;
    }

    setChecked((prev) =>
      prev.includes(id) ? prev.filter((v) => v !== id) : [...prev, id]
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit && onSubmit(checked);
  };

  return (
    <>
      <div className="approval-modal-backdrop" onClick={onClose} />
      <div className="approval-modal">
        <div className="approval-modal-title">
          Согласование финансового плана
        </div>
        <div className="approval-modal-warning">
          <span className="approval-modal-warning-icon">⚠️</span>
          <span>
            Подтвердите отправку финансового плана на согласование. После этого
            его нельзя будет редактировать.
          </span>
        </div>
        <div className="approval-modal-label">
          Выберите кому отправить на согласование:
        </div>
        <form onSubmit={handleSubmit}>
          <div className="approval-modal-list">
            {approvers.map((a) => (
              <label
                key={a.id}
                className={`approval-checkbox-label${
                  checked.includes(a.id) ? " checked" : ""
                }${a.isRequired ? " required" : ""}`}
              >
                <input
                  type="checkbox"
                  checked={checked.includes(a.id)}
                  onChange={() => handleToggle(a.id)}
                  disabled={a.isRequired}
                />
                <span className="approval-checkbox-title">
                  {a.title}
                  {a.isRequired && (
                    <span className="required-indicator"> *</span>
                  )}
                </span>
                <span className="approval-checkbox-name">{a.name}</span>
              </label>
            ))}
          </div>
          <div className="approval-modal-actions">
            <button
              type="button"
              className="approval-btn outline"
              onClick={onClose}
              disabled={isSubmitting}
            >
              Отмена
            </button>
            <button
              type="submit"
              className="approval-btn green"
              disabled={isSubmitting || checked.length === 0}
            >
              {isSubmitting ? "Отправка..." : "Отправить"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default ApprovalModal;
